import { useMutation } from "@tanstack/react-query";

import { getBeeMedia } from "generated/api/bee-media";
import type { ApplyBrandStyleRequest, BeeContentDTO } from "generated/schemas";

const beeApi = getBeeMedia();

/**
 * Mutation hook for "apply brand styles" — used by the Update Client Theme
 * modal to preview / persist re-themed BEE content.
 *
 * The response (`BeeContentDTO`) carries `htmlOutput` + `jsonOutput`; the
 * caller is responsible for stitching them into a new touchpoint version.
 */
export const useApplyBrandStyles = () =>
  useMutation<BeeContentDTO, Error, ApplyBrandStyleRequest>({
    mutationFn: (request) => beeApi.applyBrandStyles(request),
  });
